import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClientService } from './http-client.service';
import { Observable } from 'rxjs';
import { OtroEmpleador } from '../models/otroEmpleador';
import { OtroEmpleadorConcepto } from '../models/otroEmpleadorConcepto';

const baseUrl = environment.hostService + '/OtroEmpleador';

@Injectable({
  providedIn: 'root'
})
export class OtroEmpleadorService {

  constructor(private _http: HttpClientService) { }

  getAll(): Observable<any>
  {
    return this._http.get<any>({ url: baseUrl + '/Index' })
  }

  getByPersonalId(personalId: number): Observable<any>
  {
    return this._http.get<any>({ url: baseUrl + '/GetByPersonalId/' + personalId })
  }

  getHistoryByPersonalId(personalId: number): Observable<any>
  {
    return this._http.get<any>({ url: baseUrl + '/GetHistoryByPersonalId/' + personalId })
  }

  save(otroEmpleador: OtroEmpleador, otroEmpleadorConcepto: OtroEmpleadorConcepto[], cortarRegistro: boolean): Observable<any>
  {
    otroEmpleador.otroEmpleadorConcepto = otroEmpleadorConcepto;
    return this._http.post<any>({ url: baseUrl + '/Save/' + cortarRegistro, body: otroEmpleador });
  }

  delete(id: number)
  {
    return this._http.get<any>({ url: baseUrl + '/Delete?id=' + id });
  }

  deleteConcepto(id: number)
  {
    return this._http.get<any>({ url: baseUrl + '/DeleteConcepto?id=' + id });
  }

  guardarConcepto(data): Observable<any>
  {
    return this._http.post<any>({ url: baseUrl + '/UpdateConcepto', body: data, cacheMins: 0 });
  }

  mostrarConceptos(otroEmpleadorId: number)
  {
    return this._http.get<any>({ url: baseUrl + '/MostrarConceptos/' + otroEmpleadorId })
  }
  
}

